<template>
    <div v-if="weather"
        class="h-full bg-gradient-to-br from-blue-900/40 to-blue-900/20 backdrop-blur-lg rounded-2xl p-6 text-white border border-white/10 relative overflow-hidden group hover:border-blue-500/30 transition duration-300">
        <div
            class="absolute top-0 right-0 p-8 opacity-10 transform scale-150 rotate-12 group-hover:scale-175 transition duration-700">
            <i class="fas fa-cloud-sun text-8xl"></i>
        </div>

        <div class="relative z-10 flex flex-col h-full justify-between">
            <div>
                <h3 class="text-xl font-bold mb-1 flex items-center">
                    <i class="fas fa-temperature-high mr-2 text-blue-400"></i> Meteo Circuito
                </h3>
                <p class="text-blue-200 text-sm font-medium opacity-80 uppercase tracking-wider">{{ locationName }}</p>
            </div>

            <div class="mt-6">
                <div class="flex items-center mb-2">
                    <div class="text-6xl font-bold mr-4 tracking-tighter">{{ weather.current.temperature_2m }}°</div>
                    <div class="flex flex-col">
                        <span class="text-xl font-semibold">{{ getWeatherDescription(weather.current.weather_code)
                            }}</span>
                        <span class="text-sm text-blue-200">Precipitazioni: {{
                            weather.hourly.precipitation_probability[0] }}%</span>
                    </div>
                </div>
                <div
                    class="inline-flex items-center px-3 py-1 bg-black/20 rounded-full text-xs text-blue-200 border border-white/5">
                    <i class="fas fa-wind mr-2"></i> Vento: {{ weather.current.wind_speed_10m }} km/h
                </div>
            </div>
        </div>
    </div>
    <div v-else
        class="h-full bg-white/5 backdrop-blur-md rounded-2xl p-6 text-white border border-white/10 animate-pulse">
        <div class="h-6 bg-white/10 rounded w-1/2 mb-4"></div>
        <div class="h-10 bg-white/10 rounded w-1/3"></div>
    </div>
</template>

<script>
export default {
    name: 'WeatherCard',
    props: {
        weather: {
            type: Object,
            default: null
        },
        locationName: {
            type: String,
            default: 'Unknown Location'
        }
    },
    setup() {
        const getWeatherDescription = (code) => {
            // WMO Weather interpretation codes (WW)
            const codes = {
                0: 'Cielo sereno',
                1: 'Prevalentemente sereno',
                2: 'Parzialmente nuvoloso',
                3: 'Coperto',
                45: 'Nebbia',
                48: 'Nebbia con brina',
                51: 'Pioviggine leggera',
                53: 'Pioviggine moderata',
                55: 'Pioviggine densa',
                61: 'Pioggia leggera',
                63: 'Pioggia moderata',
                65: 'Pioggia intensa',
                71: 'Neve leggera',
                73: 'Neve moderata',
                75: 'Neve intensa',
                95: 'Temporale',
            };
            return codes[code] || 'Unknown';
        };

        return {
            getWeatherDescription
        };
    }
}
</script>
